module.exports = __webpack_public_path__ + "img/cer_null.679393e1.png";